module.exports = __webpack_public_path__ + "static/img/loginleft.9c8ccb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loginleft.png
// module id = e6An
// module chunks = 1